<template>
  <PageLayout>
    <h2 class="text-h3 navy--text text--darken-1 font-weight-bold pb-4">
      Dashboard
    </h2>
    <v-row>
      <v-col>
        <button
          class="d-block primary white--text rounded py-12 text-body-2 text-center shadow--hover-alt fill-width font-weight-medium"
          v-ripple
          @click="onNewAudienceClick"
        >
          Vytvořit nové publikum
        </button>
      </v-col>
      <v-col>
        <button
          class="d-block primary white--text rounded py-12 text-body-2 text-center shadow--hover-alt fill-width font-weight-medium"
          v-ripple
          @click="onNewAdClick"
        >
          Vytvořit novou reklamu
        </button>
      </v-col>
    </v-row>
    <v-row class="mb-6">
      <v-col cols="12" md="4" @click="onFilterClick('ACTIVE')">
        <ui-gradient-button color="azure">
          <div class="text-h2">{{ stats.active }}</div>
          <div class="text-body-2 font-weight-medium">aktivních reklam</div>
          <template #icon>
            <icon-dashboard-laptop />
          </template>
        </ui-gradient-button>
      </v-col>
      <v-col cols="12" md="4" @click="onFilterClick('INACTIVE')">
        <ui-gradient-button color="indigo">
          <div class="text-h2">{{ stats.paused }}</div>
          <div class="text-body-2 font-weight-medium">neaktivních reklam</div>
          <template #icon>
            <icon-dashboard-pencil-ruler />
          </template>
        </ui-gradient-button>
      </v-col>
      <v-col cols="12" md="4">
        <ui-gradient-button color="amber">
          <div class="text-h2">{{ stats.dailyBudget }} Kč</div>
          <div class="text-body-2 font-weight-medium">denní útrata</div>
          <template #icon>
            <icon-dashboard-paying />
          </template>
        </ui-gradient-button>
      </v-col>
    </v-row>
    <h3 class="text-h4 mb-5">
      {{ filterName }}
    </h3>
    <div>
      <ads-table :filter="filter" />
      <!-- TODO: ads table -->
    </div>
  </PageLayout>
</template>

<script>
import { call, get } from "vuex-pathify"

import PageLayout from "@/components/page/home/PageLayout"
import AdsTable from "@/components/ui/ads/AdsTable"
import IconDashboardLaptop from "@/components/icon/dashboard/Laptop"
import IconDashboardPaying from "@/components/icon/dashboard/Paying"
import IconDashboardPencilRuler from "@/components/icon/dashboard/PencilRuler"
import { getAdStatus } from "@/model/entity/Ad"

export default {
  name: "DashboardIndex",
  components: {
    AdsTable,
    PageLayout,
    IconDashboardLaptop,
    IconDashboardPaying,
    IconDashboardPencilRuler,
  },
  computed: {
    ...get("ads", ["ads"]),
    stats() {
      const stats = {
        active: 0,
        paused: 0,
        dailyBudget: 0,
      }

      this.ads.forEach(ad => {
        if (getAdStatus(ad) === "ACTIVE") {
          stats.active++

          if (ad.adset.dailyBudget > 0) {
            stats.dailyBudget += Math.floor(ad.adset.dailyBudget / 100)
          }
        } else {
          stats.paused++
        }

        // if (ad.adset.budgetType === "daily") {
        //   stats.dailyBudget += Math.floor(ad.adset.budget / 100)
        // } else if (ad.adset.dailyBudget) {
        //   stats.dailyBudget += Math.floor(parseInt(ad.adset.dailyBudget) / 100)
        // }
      })

      return stats
    },
    filterName() {
      return this.filter === "ACTIVE" ? "Aktivní reklamy" : "Neaktivní reklamy"
    },
  },
  data() {
    return {
      filter: "ACTIVE",
    }
  },
  methods: {
    ...call("ads", ["clearAdModel", "loadAds"]),
    ...call("audiences", ["clearAudienceModel"]),
    onNewAdClick() {
      this.clearAdModel()
      this.$router.push("/ads/new")
    },
    onNewAudienceClick() {
      this.clearAudienceModel()
      this.$router.push("/audiences/new")
    },
    onFilterClick(filter) {
      this.filter = filter
    },
  },
  mounted() {
    this.loadAds()
  },
}
</script>
